declare global {
  let dataLayer: TrackingEvent[];
}

export enum CalendarType {
  Underwriting = 'underwriting',
  Sales = 'sales',
  SalesTopUp = 'sales-top-up',
  Idd = 'idd-consultation',
  IddTopUp = 'idd-consultation-top-up',
  IddDental = 'idd-consultation-dental',
  ExpatIdd = 'expat-idd-consultation',
  SalesExpat = 'sales-expat',
  SalesDental = 'sales-dental',
  SalesClinic = 'sales-clinic',
  Signup = 'signup',
  ExpatSignup = 'expat-signup',
  FollowUp = 'follow-up',
  ExpatFollowUp = 'expat-follow-up',
  Upselling = 'upselling',
  ExpatUpselling = 'expat-upselling',
  Bap = 'bap',
  ExpatBap = 'expat-bap'
}

export interface AppointmentSlot {
  start: string;
  end: string;
}

export interface PreviousAppointmentLocalstorage {
  email: string;
  phone: string;
  appointmentId?: string;
  isCallback?: boolean;
  consentConfirmed?: boolean;
}

export enum OccupationStatus {
  Employed = 'employed',
  SelfEmployed = 'self-employed',
  Unemployed = 'unemployed',
  Student = 'student',
  CivilServant = 'civil-servant',
  CivilServantApplicant = 'civil-servant-applicant',
  Retired = 'pensioner',
  Trainee = 'trainee',
  Undefined = 'na'
}

export enum Interest {
  Comprehensive = 'comprehensive',
  CivilServant = 'civil-servant',
  Dental = 'dental',
  Clinic = 'clinic',
  General = 'general'
}

export enum IncomeKey {
  less = 'less',
  ThirtyToFourty = '30to40',
  ThirtyToSixtyFive = '30to65',
  FourtyToSixty = '40to60',
  More = 'more',
  None = 'no'
}

export enum Language {
  German = 'de',
  English = 'en'
}

export enum VisaStatus {
  Limited = 'Limited',
  Unlimited = 'Unlimited'
}

export enum Gender {
  Male = 'male',
  Female = 'female'
}
export enum InsuranceCategory {
  Full = 'full',
  Residual = 'residual',
  Collective = 'collective',
  Clinic = 'clinic',
  Dental = 'dental',
  Unknown = 'na'
}

export enum InsuranceGroup {
  EmployeeOrSelfEmployed = 'employee_self-employed',
  Expat = 'expat',
  Student = 'student',
  Clinic = 'clinic',
  Dental = 'dental',
  CivilServant = 'civil-servant',
  CivilServantApplicant = 'civil-servant-applicant',
  Collective = 'collective',
  Unknown = 'na'
}

export interface AppointmentSlot {
  start: string;
  end: string;
  id?: string;
}

export interface TrackingEvent extends CustomDimensions {
  event: string;
  element_section?: string;
  element_detail?: string;
  link_text?: string;
  link_url?: string;
  leadsUserData?: LeadsUserData | Sha256LeadsUserData;
  rejection_reason?: string;
  page_artifacts?: 'craft';
  page_artifacts_grouping?: string;
  page_funnel_position?: string;
  page_funnel_detail?: string;
  page_location?: string;
  page_title?: string;
}

export interface LeadsUserData {
  email_address?: string;
  phone_number?: string;
  address?: {
    first_name?: string;
    last_name?: string;
  };
}

export interface Sha256LeadsUserData {
  sha256_email_address?: string;
  sha256_phone_number?: string;
  address?: {
    sha256_first_name?: string;
    sha256_last_name?: string;
  };
}

export type CustomDimensions = {
  age?: number;
  yob?: number;
  gender?: Gender;
  visa?: string;
  page_insurance_category?: InsuranceCategory;
  page_insurance_group?: InsuranceGroup;
  insurance_category?: InsuranceCategory;
  insurance_group?: InsuranceGroup;
  job_status?: OccupationStatus | 'na';
  tariff?: string;
  income?: string;
  jaeg_reached?: 1 | 0; // YES = 1, NO = ;
  zip?: number;
  nationality?: string;
  form_step?: number;
  consultation_type?: ConsultationType;
  doi_status?: DoiStatus;
  deductible?: number | string;
  selection_preset?: string;
  error_type?: string;
  retention_reason?: string;
};

export interface BookConsultationPayload {
  contact_details: ContactDetails;
  appointment?: AppointmentSlot;
  calendar?: CalendarType;
  metadata?: LeadMetadata;
  utm_parameters?: UTMParameters;
  otto_solution_key?: string;
  verify_captcha?: boolean;
}

export enum ConsultationType {
  Callback = 'callback',
  Appointment = 'appointment',
  Offer = 'offer'
}

export interface ContactDetails {
  first_name?: string;
  last_name?: string;
  name?: string;
  email?: string;
  phone_number?: string;
  company?: string;
  date_of_birth?: string;
  type?: string;
  nationality?: string;
  visa?: VisaStatus;
  employment?: OccupationStatus;
  landing_page_language?: Language;
  code?: string;
  campaign?: string;
  lead?: string;
  interest?: Interest;
  message?: string;
  lead_source?: string;
  payback_number?: string;
  income?: string;
  postal_code?: string;
  document_name?: string;
  insurance_group?: InsuranceGroup;
}

export interface LeadMetadata {
  origin: 'website';
  ottonova_tracking_id?: string;
  google_tracking_id?: string;
  google_analytics_client_id?: string;
  google_click_id?: string;
  partner_id?: string;
  tippgeber_id?: string;
  google_analytics_client_fpid?: string;
  product_type?: Interest;
}

export interface UTMParameters {
  first_campaign?: string;
  first_content?: string;
  first_medium?: string;
  first_source?: string;
  first_term?: string;
  last_campaign?: string;
  last_content?: string;
  last_medium?: string;
  last_source?: string;
  last_term?: string;
  marketing_lead_source?: string;
  utm_source?: string;
  utm_campaign?: string;
}

export enum AppointmentType {
  Consultation = 'consultation',
  Idd = 'idd',
  Underwriting = 'underwriting',
  Signup = 'signup',
  FollowUp = 'follow-up',
  Upselling = 'upselling',
  Bap = 'bap'
}

export enum AppointmentStatus {
  Pending = 'pending',
  Expired = 'expired',
  Confirmed = 'confirmed',
  Cancelled = 'cancelled',
  Missed = 'missed',
  RescheduleRequested = 'reschedule requested',
  Rescheduled = 'rescheduled'
}

export interface AppointmentDetails {
  id: string;
  type: AppointmentType;
  status: AppointmentStatus;
  calendar_type: CalendarType;
  incorrect_phone_number?: boolean;
  cancellation_reason?: string;
  start: string;
  end: string;
  doi_enabled?: boolean;
  created_at?: string;
  updated_at?: string;
}

export interface ConsultationResponse {
  message: string;
  appointmentId?: string;
  appointment_details?: AppointmentDetails;
  doi?: boolean;
  consent_confirmed?: boolean;
}
export enum DoiStatus {
  Pending = 'pending',
  Validated = 'validated',
  Disabled = 'disabled',
  Unknown = 'na'
}
